import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { CTA_CONFIG } from './cta.config';
import { buildLeadPayload } from './buildLeadPayload';

const COUNTRIES = [
  'United Arab Emirates','France','United Kingdom','United States','Canada','Germany','Italy','Spain','Switzerland','Belgium',
  'Luxembourg','Netherlands','Portugal','Greece','Cyprus','Monaco','Saudi Arabia','Qatar','Kuwait','Bahrain',
  'Oman','Jordan','Lebanon','Egypt','Morocco','Tunisia','Algeria','Turkey','India','Pakistan',
  'China','Singapore','Hong Kong','Japan','South Korea','Thailand','Indonesia','Malaysia','South Africa','Nigeria',
  'Kenya','Australia','New Zealand','Brazil','Mexico','Argentina','Russia','Kazakhstan','Ukraine','Serbia'
];

const COUNTRY_CODES = [
  { code: '+971', label: 'UAE +971' },
  { code: '+33', label: 'France +33' },
  { code: '+44', label: 'UK +44' },
  { code: '+1', label: 'USA/Canada +1' },
  { code: '+49', label: 'Germany +49' },
  { code: '+39', label: 'Italy +39' },
  { code: '+34', label: 'Spain +34' },
  { code: '+41', label: 'Switzerland +41' },
  { code: '+32', label: 'Belgium +32' },
  { code: '+352', label: 'Luxembourg +352' },
  { code: '+212', label: 'Morocco +212' },
  { code: '+213', label: 'Algeria +213' },
  { code: '+216', label: 'Tunisia +216' },
  { code: '+20', label: 'Egypt +20' },
  { code: '+966', label: 'Saudi +966' },
  { code: '+974', label: 'Qatar +974' },
  { code: '+965', label: 'Kuwait +965' },
  { code: '+968', label: 'Oman +968' },
  { code: '+973', label: 'Bahrain +973' },
  { code: '+961', label: 'Lebanon +961' },
  { code: '+962', label: 'Jordan +962' },
  { code: '+90', label: 'Turkey +90' },
  { code: '+7', label: 'Russia/Kazakhstan +7' },
  { code: '+91', label: 'India +91' },
  { code: '+92', label: 'Pakistan +92' },
  { code: '+86', label: 'China +86' }
];

const BUDGET_RANGES = [
  'Below 250K',
  '250K - 500K',
  '500K - 1M',
  '1M - 2M',
  '2M - 5M',
  '5M - 10M',
  '10M+'
];

const translations = {
  En: {
    contactTitle: 'PRIVATE INQUIRY',
    contactSub: 'Initiate the strategic dialogue for your sovereignty.',
    subOpt0: '-- Select subject * --',
    subOpt1: 'Wealth Advisory',
    subOpt2: 'Real Estate',
    subOpt3: 'Digital Assets',
    subOpt4: 'Corporate Sovereignty',
    subOpt5: 'Janus Circle',
    name: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone number',
    country: 'Country of Residence',
    budgetRange: 'Budget range',
    budgetAmount: 'Exact amount',
    budgetUnknown: "I don't know yet",
    message: 'Message',
    timeline: '-- Select timeline --',
    financing: '-- Select financing --',
    otpTitle: 'VERIFICATION REQUIRED',
    otpSub: 'Please enter the code sent to your email.',
    otpLabel: '6-digit code',
    verifyBtn: 'VERIFY & DOWNLOAD',
    successMsg: 'Thank you! Your request has been received.',
    errorMsg: 'An error occurred, please try again.'
  },
  Fr: {
    contactTitle: 'REQUÊTE PRIVÉE',
    contactSub: 'Initier le dialogue stratégique pour votre souveraineté.',
    subOpt0: "-- Sélectionnez l'objet * --",
    subOpt1: 'Conseil en Stratégie Patrimoniale',
    subOpt2: 'Investissement Immobilier',
    subOpt3: 'Digital Assets',
    subOpt4: 'Souveraineté Corporative',
    subOpt5: 'Le Cercle Janus',
    name: 'Prénom',
    lastName: 'Nom',
    email: 'Email professionnel',
    phone: 'Téléphone',
    country: 'Pays de résidence',
    budgetRange: 'Tranche de budget',
    budgetAmount: 'Montant précis',
    budgetUnknown: 'Je ne sais pas encore',
    message: 'Message',
    timeline: "-- Sélectionnez l'horizon --",
    financing: '-- Sélectionnez le financement --',
    otpTitle: 'VÉRIFICATION REQUISE',
    otpSub: 'Veuillez entrer le code envoyé par email.',
    otpLabel: 'Code à 6 chiffres',
    verifyBtn: 'VÉRIFIER ET TÉLÉCHARGER',
    successMsg: 'Merci ! Votre demande a bien été reçue.',
    errorMsg: 'Une erreur est survenue, veuillez réessayer.'
  },
  Ar: {
    contactTitle: 'استفسار خاص',
    contactSub: 'ابدأ الحوار الاستراتيجي من أجل سيادتك.',
    subOpt0: '-- حدد الموضوع * --',
    subOpt1: 'استشارات الثروات',
    subOpt2: 'استثمار عقاري',
    subOpt3: 'الأصول الرقمية',
    subOpt4: 'سيادة الشركات',
    subOpt5: 'دائرة جانوس',
    name: 'الاسم',
    lastName: 'العائلة',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    country: 'بلد الإقامة',
    budgetRange: 'شريحة الميزانية',
    budgetAmount: 'المبلغ الدقيق',
    budgetUnknown: 'لا أعرف بعد',
    message: 'رسالة',
    timeline: '-- اختر الإطار الزمني --',
    financing: '-- اختر التمويل --',
    otpTitle: 'مطلوب التحقق',
    otpSub: 'الرجاء إدخال الرمز المرسل إلى بريدك الإلكتروني.',
    otpLabel: 'رمز من 6 أرقام',
    verifyBtn: 'تحقق وتحميل',
    successMsg: 'شكرا لك! تم استلام طلبك بنجاح.',
    errorMsg: 'حدث خطأ، يرجى المحاولة مرة أخرى.'
  }
};

const getInitialLang = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem('januslang') || window.localStorage.getItem('janus_lang') || 'En';
  }
  return 'En';
};

function sanitizePhoneInput(value) {
  return String(value || '').replace(/\D/g, '').replace(/^0+/, '');
}

function triggerNativeFileDownload(action, fields) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;
  form.style.display = 'none';

  Object.entries(fields).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value == null ? '' : String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 1500);
}

export default function GlobalContactModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [lang, setLang] = useState(getInitialLang());
  const [status, setStatus] = useState('idle');
  const [modalConfig, setModalConfig] = useState(CTA_CONFIG.home);
  const [contextData, setContextData] = useState({});
  const [otpEmail, setOtpEmail] = useState('');

  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    countryCode: '+971',
    budgetRange: '',
    budgetAmount: '',
    budgetUnknown: false,
    currency: 'USD',
    message: '',
    subject: '',
    listingType: '',
    financing: '',
    country: '',
    timeline: '',
    otpCode: ''
  });

  useEffect(() => {
    const openModal = (e) => {
      const detail = e?.detail || {};
      const source = detail.source || detail.ctaKey || 'home';
      const config = CTA_CONFIG[source] || CTA_CONFIG.home;
      const defaults = config.defaults || {};

      setModalConfig(config);
      setContextData(detail);
      setOtpEmail('');
      setFormData({
        name: '',
        lastName: '',
        email: '',
        phone: '',
        countryCode: '+971',
        budgetRange: '',
        budgetAmount: '',
        budgetUnknown: false,
        currency: 'USD',
        message: '',
        subject: defaults.subject || '',
        listingType: detail.listingType || '',
        financing: '',
        country: '',
        timeline: '',
        otpCode: ''
      });
      setStatus('idle');
      setIsOpen(true);
    };

    const handleLang = () => setLang(getInitialLang());

    window.addEventListener('openContactModal', openModal);
    window.addEventListener('langchange', handleLang);
    window.addEventListener('janus_lang_changed', handleLang);

    return () => {
      window.removeEventListener('openContactModal', openModal);
      window.removeEventListener('langchange', handleLang);
      window.removeEventListener('janus_lang_changed', handleLang);
    };
  }, []);

  const t = translations[lang] || translations.En;
  const fields = modalConfig.fields || {};
  const required = modalConfig.required || {};
  const labels = modalConfig.labels?.[lang] || modalConfig.labels?.En || {};
  const subtitle = labels.subtitle || t.contactSub;

  const realEstateNeedsListingType = useMemo(() => {
    return formData.subject === 'real-estate' && fields.listingType;
  }, [formData.subject, fields.listingType]);

  if (!isOpen) return null;

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const ctx = {
        purpose: formData.subject || modalConfig.defaults?.subject || '',
        mode: modalConfig.mode,
        propertyId: contextData.propertyId || '',
        propertyTitle: contextData.propertyTitle || contextData.title || '',
        title: contextData.title || contextData.propertyTitle || '',
        slug: contextData.slug || contextData.propertySlug || '',
        propertySlug: contextData.propertySlug || contextData.slug || '',
        lang,
        source: contextData.source || modalConfig.ctaKey || 'home',
        sourcePage: contextData.sourcePage || contextData.source || modalConfig.ctaKey || 'public-site',
        sourceUrl: contextData.sourceUrl || window.location.href,
        sourceTitle: contextData.sourceTitle || contextData.title || contextData.propertyTitle || document.title,
        sourceCategory: contextData.sourceCategory || modalConfig.requestType || '',
        ctaKey: contextData.ctaKey || modalConfig.ctaKey || 'home',
        requestType: modalConfig.requestType || ''
      };

      const payload = buildLeadPayload(formData, ctx);
      const res = await axios.post(modalConfig.endpoint, payload);

      if (res.data.success) {
        if (['brochureRequest', 'paymentPlanRequest'].includes(modalConfig.mode)) {
          setOtpEmail(payload.email);
          setStatus('otp-pending');
        } else {
          setStatus('success');
          setTimeout(() => setIsOpen(false), 2500);
        }
      } else {
        setStatus('idle');
        alert(t.errorMsg);
      }
    } catch (err) {
      setStatus('idle');
      alert(err.response?.data?.message || t.errorMsg);
    }
  };

  const handleOtpVerify = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      triggerNativeFileDownload(modalConfig.verifyEndpoint, {
        email: otpEmail || formData.email,
        otp: formData.otpCode,
        propertyId: contextData.propertyId || '',
        propertySlug: contextData.propertySlug || contextData.slug || '',
        sourcePage: contextData.sourcePage || contextData.source || modalConfig.ctaKey || 'public-site',
        requestType: modalConfig.requestType || 'brochure',
        mode: modalConfig.mode || 'brochureRequest'
      });

      setStatus('success');
      setTimeout(() => setIsOpen(false), 1500);
    } catch (_) {
      setStatus('otp-pending');
      alert(t.errorMsg);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" dir={'ltr'}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md overflow-hidden pointer-events-none">
        <img
          src="https://januscapitalstrategy.com/uploads/images/JANUS_BACKGROUND.webp"
          alt="Luxury Real Estate Villa Backdrop"
          className="w-full h-full object-cover opacity-25 scale-105 select-none"
        />
      </div>

      <div className="bg-[#fdfdfd] text-black p-10 max-w-2xl w-full relative rounded-sm shadow-2xl overflow-y-auto max-h-[90vh] z-10">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-5 right-5 text-gray-400 hover:text-black transition text-xl cursor-pointer"
        >
          ✕
        </button>

        {status === 'success' ? (
          <div className="text-center py-20">
            <h3 className="text-2xl font-light text-black uppercase mb-4">{t.successMsg}</h3>
          </div>
        ) : status === 'otp-pending' ? (
          <div className="text-center">
            <h3 className="text-2xl font-light text-black uppercase">{t.otpTitle}</h3>
            <p className="text-gray-400 font-bold text-xs uppercase tracking-[0.3em] mt-2 mb-8">{t.otpSub}</p>
            <form onSubmit={handleOtpVerify} className="space-y-6">
              <input
                type="text"
                placeholder={t.otpLabel}
                required
                className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-center tracking-[0.5em] text-2xl font-black"
                onChange={e => setFormData({ ...formData, otpCode: e.target.value })}
                value={formData.otpCode}
                maxLength={6}
              />
              <button
                type="submit"
                className="w-full bg-black text-white py-4 text-xs font-bold uppercase tracking-widest hover:bg-[#C5A059] transition rounded-sm cursor-pointer flex justify-center items-center"
              >
                {status === 'loading' ? '...' : t.verifyBtn}
              </button>
            </form>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              <h3 className="text-2xl font-light text-black uppercase">
                {labels.title || t.contactTitle}
              </h3>
              <p className="text-gray-400 font-bold text-xs uppercase tracking-[0.3em] mt-2">
                {contextData.title ? `Ref: ${contextData.title}` : subtitle}
              </p>
            </div>

            <form onSubmit={handleFormSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              {fields.subject && (
                <div className="col-span-2 space-y-4">
                  <select
                    required={!!required.subject}
                    value={formData.subject}
                    onChange={e => {
                      const val = e.target.value;
                      setFormData(prev => ({
                        ...prev,
                        subject: val,
                        listingType: val === 'real-estate' ? prev.listingType : ''
                      }));
                    }}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none focus:border-black transition font-bold text-sm"
                  >
                    <option value="">{t.subOpt0}</option>
                    <option value="wealth-advisory">{t.subOpt1}</option>
                    <option value="real-estate">{t.subOpt2}</option>
                    <option value="digital-assets">{t.subOpt3}</option>
                    <option value="corporate-sovereignty">{t.subOpt4}</option>
                    <option value="janus-circle">{t.subOpt5}</option>
                  </select>

                  {realEstateNeedsListingType && (
                    <select
                      required
                      value={formData.listingType}
                      onChange={e => setFormData({ ...formData, listingType: e.target.value })}
                      className="w-full p-4 bg-white border border-[#C5A059] rounded-xl text-black outline-none focus:border-black transition font-bold text-sm shadow-sm"
                    >
                      <option value="">{lang === 'Fr' ? '-- Type de Transaction * --' : '-- Transaction Type * --'}</option>
                      <option value="off-plan">Off-Plan</option>
                      <option value="secondary">Secondary Market</option>
                      <option value="rental">Rental</option>
                      <option value="commercial">Commercial</option>
                      <option value="leisure">Leisure</option>
                    </select>
                  )}
                </div>
              )}

              <input
                type="text"
                placeholder={t.name}
                required
                className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm uppercase"
                onChange={e => setFormData({ ...formData, name: e.target.value.toUpperCase() })}
                value={formData.name}
              />

              <input
                type="text"
                placeholder={t.lastName}
                required
                className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm uppercase"
                onChange={e => setFormData({ ...formData, lastName: e.target.value.toUpperCase() })}
                value={formData.lastName}
              />

              <input
                type="email"
                placeholder={t.email}
                required
                className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                onChange={e => setFormData({ ...formData, email: e.target.value })}
                value={formData.email}
              />

              <div className="grid grid-cols-[140px_1fr] gap-3">
                <select
                  value={formData.countryCode}
                  onChange={e => setFormData({ ...formData, countryCode: e.target.value })}
                  className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                >
                  {COUNTRY_CODES.map(item => (
                    <option key={item.code} value={item.code}>{item.label}</option>
                  ))}
                </select>

                <input
                  type="tel"
                  placeholder={t.phone}
                  required
                  className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                  onChange={e => setFormData({ ...formData, phone: sanitizePhoneInput(e.target.value) })}
                  value={formData.phone}
                />
              </div>

              {fields.country && (
                <select
                  className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                  onChange={e => setFormData({ ...formData, country: e.target.value })}
                  value={formData.country}
                >
                  <option value="">{t.country}</option>
                  {COUNTRIES.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </select>
              )}

              {fields.timeline && (
                <select
                  className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                  value={formData.timeline}
                  onChange={e => setFormData({ ...formData, timeline: e.target.value })}
                >
                  <option value="">{t.timeline}</option>
                  <option value="immediate">Immediate</option>
                  <option value="1-3-months">1-3 Months</option>
                  <option value="3-6-months">3-6 Months</option>
                  <option value="6-12-months">6-12 Months</option>
                  <option value="long-term">Long Term</option>
                </select>
              )}

              {fields.budgetRange && (
                <select
                  className="col-span-2 p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                  value={formData.budgetRange}
                  disabled={formData.budgetUnknown}
                  onChange={e => setFormData({ ...formData, budgetRange: e.target.value })}
                >
                  <option value="">{t.budgetRange}</option>
                  {BUDGET_RANGES.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </select>
              )}

              {fields.budgetAmount && (
                <div className="col-span-2 flex gap-2">
                  <input
                    type="number"
                    placeholder={t.budgetAmount}
                    disabled={formData.budgetUnknown}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                    onChange={e => setFormData({ ...formData, budgetAmount: e.target.value })}
                    value={formData.budgetAmount}
                  />
                  <select
                    className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm font-bold w-24"
                    value={formData.currency}
                    disabled={formData.budgetUnknown}
                    onChange={e => setFormData({ ...formData, currency: e.target.value })}
                  >
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="AED">AED</option>
                    <option value="BTC">BTC</option>
                    <option value="USDT">USDT</option>
                  </select>
                </div>
              )}

              {fields.budgetAmount && (
                <label className="col-span-2 flex items-center gap-3 text-sm">
                  <input
                    type="checkbox"
                    checked={formData.budgetUnknown}
                    onChange={e => setFormData({
                      ...formData,
                      budgetUnknown: e.target.checked,
                      budgetRange: e.target.checked ? '' : formData.budgetRange,
                      budgetAmount: e.target.checked ? '' : formData.budgetAmount
                    })}
                  />
                  <span>{t.budgetUnknown}</span>
                </label>
              )}

              {fields.financing && (
                <div className="col-span-2">
                  <select
                    value={formData.financing}
                    onChange={e => setFormData({ ...formData, financing: e.target.value })}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm"
                  >
                    <option value="">{t.financing}</option>
                    <option value="cash">Cash / Bank Transfer</option>
                    <option value="payment-plan">Developer Payment Plan</option>
                    <option value="mortgage">Mortgage</option>
                  </select>
                </div>
              )}

              {fields.message && (
                <textarea
                  required={!!required.message}
                  placeholder={t.message}
                  rows="3"
                  className="col-span-2 p-4 bg-gray-50 border border-gray-200 rounded-xl text-black outline-none text-sm resize-none"
                  onChange={e => setFormData({ ...formData, message: e.target.value })}
                  value={formData.message}
                />
              )}

              <button
                disabled={status === 'loading'}
                type="submit"
                className="col-span-2 bg-black text-white py-4 text-xs font-bold uppercase tracking-widest hover:bg-[#C5A059] transition rounded-sm cursor-pointer flex justify-center items-center"
              >
                {status === 'loading' ? '...' : (labels.btn || 'SUBMIT')}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
